









































































































































































import { Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { mixins } from 'vue-class-component';
import { Route, NavigationGuardNext } from 'vue-router';
import { ValidationObserver } from 'vee-validate';
import { statusOptions, StatusOption } from '@/configs/status';
import { putResidentDetail, getResidentDetail, postResidentDetail } from '@/configs/api-path';
import CheckProjectMixin from '@/mixins/check-project';
import ApiErrorMixin from '@/mixins/api-error';
import ApiStatusMixin from '@/mixins/api-status';
import EditorActionMixin from '@/mixins/editor-action';
import { ProjectMenu, AttachProject } from '@/models/project';
import { encryptSha1 } from '@/utils/crypto';
import { ResidentDetail } from '@/models/resident';
import sleep from '@/utils/sleep';

const SECRET_SALT = process.env.VUE_APP_SECRET_SALT;

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component
export default class PageResidentEdit extends mixins(
  CheckProjectMixin, EditorActionMixin, ApiStatusMixin, ApiErrorMixin,
) {
  $refs!: {
    formObs: InstanceType<typeof ValidationObserver>;
  }

  currentProject: AttachProject | null = null;

  statusOptions: StatusOption[] = statusOptions;

  userId: number | string | null = null;

  userProjectId: number | null = null;

  userForm: ResidentDetail = {
    id: null,
    name: null,
    mobile: null,
    password: null,
    email: null,
    status: false,
    description: null,
  };

  get methodTitle() {
    return this.isCreateAction ? '新增' : '編輯';
  }

  get projectId() {
    return this.userProjectId || parseInt(this.$route.params.projectId, 10);
  }

  get submitText() {
    return this.isCreateAction ? '新增' : '儲存';
  }

  get isFormChanged() {
    return this.$refs.formObs.flags.changed;
  }

  get breadcrumb() {
    return [
      {
        text: '住戶管理',
        to: null,
      },
      {
        text: this.currentProject?.name,
        to: null,
      },
    ];
  }

  @Getter('app/getMenuProjectsAll') menuProjects!: ProjectMenu[];

  residentSubmit() {
    if (this.isCreateAction) {
      this.createResidentHandler();
    } else if (this.isEditAction) {
      this.editResidentHandler();
    }
  }

  cancelEdit() {
    if (!this.currentProject) {
      this.$router.push({
        name: 'dashboard',
      });
      return;
    }

    this.$router.push({
      name: 'resident-list',
      params: {
        projectId: this.currentProject.id || '',
      },
    });
  }

  async fetchResident() {
    const { userId } = this.$route.params;
    if (!userId) {
      return;
    }

    this.setApiLoading();
    try {
      const { data: residentResponse } = await this.$axios.get<{
        code: number;
        user: ResidentDetail;
      }>(getResidentDetail(userId));

      if (residentResponse.code === 0) {
        const { user } = residentResponse;
        this.userId = userId;
        this.userForm.name = user.name;
        this.userForm.mobile = user.mobile;
        this.userForm.email = user.email;
        this.userForm.description = user.description;
        this.userForm.status = user.status;
      } else {
        this.apiErrorCodeAlert(residentResponse.code, '編輯住戶');
        this.$router.push({
          name: 'resident-list',
          params: {
            projectId: this.currentProject?.id || '',
          },
        });
      }
    } catch (error) {
      console.error(error);
    }
    this.setApiPending();
  }

  async createResidentHandler() {
    if (!this.currentProject || !this.currentProject.id) {
      this.$notify.show('error filled', '無此建案！', '新增住戶',
        { duration: 3000, permanent: false });
      return;
    }

    this.setApiLoading();
    try {
      const password = encryptSha1(`${SECRET_SALT}${this.userForm.password}${SECRET_SALT}`);

      const residentData = {
        ...this.userForm,
        projectId: this.currentProject.id,
      };

      delete residentData.id;

      residentData.password = password;

      const { data: residentResponse } = await this.$axios.post<{
        code: number;
        user: {
          id: number;
        };
      }>(postResidentDetail, residentData);

      if (residentResponse.code === 0) {
        this.$refs.formObs.reset();
        await sleep(0.1);
        this.$notify.show('success filled', '住戶已新增！', '新增住戶',
          { duration: 3000, permanent: false });
        this.$router.push({
          name: 'resident-list',
          params: {
            projectId: this.currentProject?.id || '',
          },
        });
      } else {
        this.apiErrorCodeAlert(residentResponse.code);
      }
    } catch (error) {
      console.error(error);
    }
    this.setApiPending();
  }

  async editResidentHandler() {
    if (!this.userId) {
      return;
    }

    this.setApiLoading();
    try {
      let password;
      if (this.userForm.password !== '' && this.userForm.password !== null) {
        password = encryptSha1(`${SECRET_SALT}${this.userForm.password}${SECRET_SALT}`);
      }

      const updateData = {
        name: this.userForm.name,
        description: this.userForm.description,
        email: this.userForm.email,
        password,
      };

      const { data: updateResponse } = await this.$axios.put<{
        code: number;
        user: {
          id: number;
        };
      }>(putResidentDetail(this.userId), updateData);

      if (updateResponse.code === 0) {
        this.$refs.formObs.reset();
        await sleep(0.1);
        this.$notify.show('success filled', '資料已更新成功！', '編輯住戶',
          { duration: 3000, permanent: false });
        if (this.currentProject) {
          this.$router.push({
            name: 'resident-list',
            params: {
              projectId: this.currentProject?.id || '',
            },
          });
        }
      } else {
        this.apiErrorCodeAlert(updateResponse.code, '編輯住戶');
      }
    } catch (error) {
      console.log(error);
      // this.apiErrorCodeAlert(code);
    }
    this.setApiPending();
  }

  async checkProjectAndFetch() {
    try {
      this.setApiLoading();
      const projectExist = await this.checkProjectExistII(this.projectId);
      this.setApiPending();

      if (projectExist.code === 0) {
        this.currentProject = {
          id: projectExist.project.id,
          name: projectExist.project.name,
        };

        if (this.editorAction && this.$route.params.userId) {
          console.log('fetch resident infos');
          this.fetchResident();
        }
      } else {
        this.$notify.show('error filled', projectExist.message, '住戶管理');
      }
    } catch (error) {
      this.$notify.show('error filled', error.message, '住戶管理');
      console.error(error.message);
    }
  }

  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    if (this.isFormChanged) {
      // eslint-disable-next-line no-alert
      const confirm = window.confirm(`確定取消${this.methodTitle}？\n離開後變更的資料將不會被儲存。`);

      if (confirm === false) {
        return;
      }
      next();
      return;
    }
    next();
  }

  beforeMount() {
    this.checkProjectAndFetch();
  }
}
